<template>
  <!-- Main content -->
  <section class="content">
    <!-- 搜索 -->
    <div class="btn-box">
      <el-form :inline="true">
        <el-form-item label="频道名称：">
            <el-input v-model="search_name" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="专题ID：">
            <el-input v-model="search_id" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="频道类型">
          <el-select v-model="search_type" placeholder="">
            <el-option v-for="item in classifyList" :label="item.name" :value="item.type"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select v-model="search_status" placeholder="">
            <el-option label="全部" value=""></el-option>
            <el-option label="显示" value="1"></el-option>
            <el-option label="隐藏" value="2"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
            <el-button type="primary" @click="seach(1)">搜索</el-button>
            <el-button type="" @click="reset(1)">重置</el-button>
        </el-form-item>
    </el-form>
    </div>
    <!-- 添加按钮 -->
    <div class="btn-box">
      <el-button type="primary" size="mini" @click="add">添加</el-button>
    </div>
    <!-- 表单 -->
    <el-table 
        v-loading="loading"
        :data="informationList"
        border
        style="width: 100%;">
        <el-table-column fixed label="频道名称" prop="channel_name" width="150"></el-table-column>
        <el-table-column label="频道类型" width="150">
          <template slot-scope="item">
            {{item.row.channel_type | type}}
          </template>
</el-table-column>
<el-table-column label="专题ID" prop="topic_id"></el-table-column>
<el-table-column label="曝光次数" prop="exposure_times"></el-table-column>
<el-table-column label="点击次数" prop="click_times"></el-table-column>
<el-table-column label="浏览需求">
    <template slot-scope="item">
            
            <div v-if="item.row.edit">
              <el-input  v-model="item.row.quantity_num" placeholder=""></el-input>
            </div>
            <span v-else>{{item.row.quantity_num}}</span>
            <el-button type="text" @click="updateInformationDate(item.row,2)">{{!item.row.edit?'修改':'确认'}}</el-button>
          </template>
</el-table-column>
<el-table-column label="状态">
    <template slot-scope="item">
              {{item.row.status | status}}
            </template>
</el-table-column>
<el-table-column label="操作">
    <template slot-scope="item">
            <el-button type="primary" size="mini" @click="getInformation(item.row.id)">修改</el-button>
            <el-button :type="item.row.status==2?'primary':'warning'" size="mini" @click="updateInformationDate(item.row,1)"> {{item.row.status==2?'显示':'隐藏'}} </el-button>
            <el-button type="danger" size="mini" @click="del(item.row.id)">删除</el-button>
        </template>
</el-table-column>
</el-table>
<!-- 分页 -->
<el-pagination background layout="total, sizes,prev, pager, next,jumper" :total="total" @size-change="sizeChange" @current-change="currentChange" :current-page="page">
</el-pagination>

<informationDialog :showExport="dialog" @clickClose="close" :platform="platform"></informationDialog>
</section>
</template>
<script>
    let common = JSON.parse(localStorage.getItem('common'))
    import * as api from "@/config/api";
    export default {
        name: 'maintenanceInformation',
        data() {
            return {
                loading: false,
                pagesize: 10,
                page: 1,
                total: 0,

                classifyList: common.channel_type_list,

                dialog: false,
                informationList: [],

                search_name: '',
                search_id: '',
                search_type: '',
                search_status: '',

                platform: {},

                Row: null,
                Col: null
            }
        },
        filters: {
            status(val) {
                switch (Number(val)) {
                    case 1:
                        return '显示'
                        break;
                    case 2:
                        return '隐藏'
                        break
                    default:
                        break;
                }
            },
            type(val) {
                let name = "";
                if (JSON.stringify(common.channel_type_list).indexOf(val) != -1) {
                    common.channel_type_list.map((a, index) => {
                        if (val == a.type) {
                            name = a.name;
                        }
                    });
                }
                return name;
            }
        },
        mounted() {
            this.getInformationList()
        },
        methods: {
            // 获取列表
            getInformationList(page, size) {
                api.getInformationList({
                    page: page ? page : this.page,
                    pagesize: size ? size : this.pagesize,
                    channel_type: this.search_type,
                    channel_name: this.search_name,
                    topic_id: this.search_id,
                    status: this.search_status,
                }, res => {
                    this.total = Number(res.data.count)

                    res.data.list.forEach(element => {
                        element.edit = false
                    });

                    this.informationList = res.data.list
                    console.log(this.informationList)

                    this.loading = false
                })
            },
            // 分页点击
            sizeChange(val) {
                this.pagesize = val
                this.getInformationList()
            },
            currentChange(val) {
                this.page = val
                this.getInformationList()
            },
            //搜索
            seach(page) {
                this.page = page
                this.getInformationList(page)
            },
            reset(page) {
                this.search_type = ''
                this.search_name = ''
                this.search_id = ''
                this.search_status = ''
                this.page = page
                this.getInformationList(page)
            },
            // 复制
            copy() {
                this.$message({
                    message: '复制成功',
                    type: 'success'
                })
            },
            // 获取详情
            getInformation(id) {
                this.id = id
                api.getInformation({
                    id: id
                }, res => {
                    this.platform = res.data
                    this.dialog = true
                })
            },
            close() {
                this.dialog = false
                this.getInformationList()
            },
            add() {
                this.platform = {}
                this.dialog = true
            },
            // 修改、添加频道分类
            alter() {
                if (this.id != '') {
                    api.updateInformation({
                        id: this.id,
                        item_id: this.item_id,
                        item_pic: this.item_pic,
                        item_title: this.item_title,
                        price: this.price,
                        end_price: this.end_price,
                        kl: this.kl,
                        invite_num: this.invite_num,
                        category_id: this.category_id,
                        weight: this.weight,
                        status: this.status,
                    }, res => {
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        })
                        this.dialog = false
                        this.getInformationList()
                    })
                    return
                }
                api.addInformation({
                    item_id: this.item_id,
                    item_pic: this.item_pic,
                    item_title: this.item_title,
                    price: this.price,
                    end_price: this.end_price,
                    kl: this.kl,
                    invite_num: this.invite_num,
                    category_id: this.category_id,
                    weight: this.weight,
                    status: this.status,
                }, res => {
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    })
                    this.dialog = false
                    this.getInformationList()
                })
            },
            // 状态、权限
            updateInformationDate(row, type) {
                // console.log(index)
                if (type == 2 && !row.edit) {
                    row.edit = true
                    return
                }
                let data = type == 1 ? {
                    type,
                    id: row.id,
                    status: row.status == 1 ? 2 : 1
                } : {
                    type,
                    id: row.id,
                    quantity_num: row.quantity_num
                }
                api.updateInformationDate(data, res => {
                    this.$message({
                        type: 'success',
                        message: res.msg
                    })

                    this.getInformationList()
                })
            },
            // 删除
            del(id) {
                this.$confirm('是否确认删除 ' + name, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.delInformation({
                        id: id
                    }, res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        this.getInformationList()
                    })
                }).catch(() => {})
            },
        }
    }
</script>
<style lang="scss">
    .btn-box {
        text-align: left;
        margin-bottom: 20px;
    }
    
    .el-image img {
        height: 40px;
    }
    
    .el-image-viewer__canvas img {
        width: auto;
        height: auto;
    }
</style>